// extracted by mini-css-extract-plugin
export default {"container":"dashBoard_container__oelC0","container__outlet":"dashBoard_container__outlet__5557b","container__outlet__box":"dashBoard_container__outlet__box__dKSDp"};